import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { mode, copy } from "@chakra-ui/theme-tools";
import Button from "./button";

var menulist = function menulist(props) {
  return {
    bg: mode("#fff", "gray.700")(props),
    boxShadow: mode("sm", "dark-lg")(props),
    color: "inherit",
    outline: 0,
    minWidth: "3xs",
    paddingY: "2",
    zIndex: "1",
    borderRadius: "md",
    borderWidth: "1px"
  };
};

var menuitem = function menuitem(props) {
  return {
    width: "100%",
    outline: 0,
    textDecoration: "none",
    paddingY: "0.4rem",
    paddingX: "0.8rem",
    transition: "background 50ms ease-in 0s",
    _focus: {
      bg: mode("gray.100", "whiteAlpha.100")(props)
    },
    _active: {
      bg: mode("gray.200", "whiteAlpha.200")(props)
    },
    _expanded: {
      bg: mode("gray.100", "whiteAlpha.100")(props)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
};

var Menu = {
  defaultProps: Button.defaultProps,
  baseStyle: function baseStyle(props) {
    return {
      MenuButton: Button.baseStyle,
      MenuList: menulist(props),
      MenuItem: menuitem(props),
      MenuGroupTitle: {
        marginX: 4,
        marginY: 2,
        fontWeight: "semibold",
        fontSize: "sm"
      }
    };
  },
  variants: _extends({}, copy(Button.variants, "MenuButton")),
  sizes: _extends({}, copy(Button.sizes, "MenuButton"))
};
export default Menu;